import { render, staticRenderFns } from "./PasosA.vue?vue&type=template&id=47dcb466&scoped=true&lang=pug&"
import script from "./PasosA.vue?vue&type=script&lang=js&"
export * from "./PasosA.vue?vue&type=script&lang=js&"
import style0 from "./PasosA.vue?vue&type=style&index=0&id=47dcb466&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcb466",
  null
  
)

export default component.exports